import {Col, Row} from 'reactstrap';
import styles from './PriceBreakdown.scss';
import React from 'react';

const PriceBreakdown = ({price, absoluteClass}) => {
  if (!price) return null;
  const priceValue = parseFloat(price);
  const serviceFee = priceValue !== 0 ? priceValue * 0.04 + 1.5 : 0;
  const processingFee = (priceValue + serviceFee) * 0.025;
  const total = priceValue + serviceFee + processingFee;

  return  <Row className={absoluteClass ? styles.ticketPriceBreakdown : ''}>
    <Col>
      <h4>Cost to Buyer</h4>
      <div>Ticket Price: ${price}</div>
      <div>Service Fee: ${serviceFee.toFixed(2)}</div>
      <div>Processing Fee: ${processingFee.toFixed(2)}</div>
      <div>Total: ${total.toFixed(2)}</div>
    </Col>
    <Col>
      <h4>Your Payout</h4>
      <div>Ticket Revenue: ${price}</div>
    </Col>
  </Row>;
};

export default PriceBreakdown;


// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/PriceBreakdown.jsx